'use client';

import { c as _c } from "react/compiler-runtime";
import { Switch } from '@repo/ui';
import { memo } from 'react';
import { trackFilterChanged } from '@/lib/analytics/client/trackers/filter';
export interface VaultV2FilterProps {
  isActive: boolean;
  onChange: (enabled: boolean) => void;
  isDisabled: boolean;
  page?: string;
}
const VaultV2Filter = t0 => {
  const $ = _c(9);
  const {
    isActive,
    onChange,
    isDisabled,
    page
  } = t0;
  let t1;
  if ($[0] !== isActive || $[1] !== onChange || $[2] !== page) {
    t1 = () => {
      const newValue = !isActive;
      onChange(newValue);
      if (page) {
        trackFilterChanged({
          filterName: "vault_v2",
          filterValue: newValue,
          page
        });
      }
    };
    $[0] = isActive;
    $[1] = onChange;
    $[2] = page;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <label htmlFor="vault-v2-filter" className="text-2xs text-secondary-foreground">Only show Vaults V2</label>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleClick || $[6] !== isActive || $[7] !== isDisabled) {
    t3 = <div className="gap-xs flex items-center">{t2}<Switch id="vault-v2-filter" checked={isActive} onCheckedChange={handleClick} disabled={isDisabled} /></div>;
    $[5] = handleClick;
    $[6] = isActive;
    $[7] = isDisabled;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default memo(VaultV2Filter);